import _ from 'lodash'
import Guid from 'guid'

export default {
    formatDestination(dest) {
        let defaultImage = {}
        let allImages = dest.get('images')
        if (allImages) {
            let findThumb = allImages.filter(function(img) {
                return img.getIn(['pivot', 'thumbnail'])
            })

            if (findThumb.size > 0) {
                defaultImage = findThumb.get(0).toJS()
            } else if (allImages.size > 0) {
                defaultImage = allImages.get(0).toJS()
            }
        }

        let tLat = dest.getIn(['opencage', 'location', 'lat']) ? dest.getIn(['opencage', 'location', 'lat']) : JSON.parse(dest.getIn(['opencage', 'location'])).lat
        let tLon = dest.getIn(['opencage', 'location', 'lon']) ? dest.getIn(['opencage', 'location', 'lon']) : JSON.parse(dest.getIn(['opencage', 'location'])).lon

        let openBounds = JSON.parse(dest.getIn(['opencage', 'bounds']))

        return {
            hasLocation: true,
            title: dest.get('name'),
            location: {
                latitude: tLat,
                longitude: tLon
            },
            opencage: {
                components: {
                    city: dest.getIn(['opencage', 'components', 'city']) ? dest.getIn(['opencage', 'components', 'city']) : dest.getIn(['opencage', 'city']),
                    country: dest.getIn(['opencage', 'components', 'country']) ? dest.getIn(['opencage', 'components', 'country']) : dest.getIn(['opencage', 'country']),
                    county: dest.getIn(['opencage', 'components', 'county']) ? dest.getIn(['opencage', 'components', 'county']) : '',
                    state: dest.getIn(['opencage', 'components', 'state']) ? dest.getIn(['opencage', 'components', 'state']) : dest.getIn(['opencage', 'state']),
                    _type: dest.getIn(['opencage', 'components', '_type']) ? dest.getIn(['opencage', 'components', '_type']) : dest.getIn(['opencage', 'oc_type'])
                },
                type: dest.getIn(['opencage', 'type']) ? dest.getIn(['opencage', 'type']) : dest.getIn(['opencage', 'oc_type']),
                bounds: JSON.stringify({
                    south: openBounds.south,
                    west: openBounds.west,
                    north: openBounds.north,
                    east: openBounds.east
                })
            },
            type: dest.get('type'),
            description: dest.get('description'),
            excerpt: dest.get('excerpt'),
            images: [defaultImage],
            id: dest.get('id'),
            price_range: {
                low: dest.getIn(['price_range', 'low']),
                medium: dest.getIn(['price_range', 'medium']),
                hight: dest.getIn(['price_range', 'high'])
            }
        }
    },

    formatAccommodation(accom, user) {
        let defaultImage = {}
        let allImages = accom.get('images')
        if (allImages) {
            let findThumb = allImages.filter(function(img) {
                return img.getIn(['pivot', 'thumbnail'])
            })

            if (findThumb.size > 0) {
                defaultImage = findThumb.get(0).toJS()
            } else if (allImages.size > 0) {
                defaultImage = allImages.get(0).toJS()
            }
        }

        const placePhotos = accom.getIn(['accommodation_place_details', 'details', 'photos'])
        let firstPlaceLandscape = placePhotos
            ? placePhotos.filter((p) => p.get('width') > p.get('height')).get(0)
            : null
        firstPlaceLandscape = firstPlaceLandscape ? [firstPlaceLandscape] : []

        return {
            added_by: user.firstname,
            accommodation_guid: accom.get('accommodation_guid') ? accom.get('accommodation_guid') : Guid.raw(),
            id: accom.get('id') ? accom.get('id') : -1,
            name: accom.get('name'),
            description: accom.getIn(['description', 'full_text']),
            location: {
                lat: accom.getIn(['location', 'lat']),
                lon: accom.getIn(['location', 'lon']),
            },
            images: [defaultImage],
            accommodation_details: {
                rating: {
                    stars: accom.getIn(['accommodation_details', 'rating', 'stars']) ? accom.getIn(['accommodation_details', 'rating', 'stars']) : null
                },
                price_range: {
                    low: accom.getIn(['accommodation_details', 'price_range', 'low']) ? accom.getIn(['accommodation_details', 'price_range', 'low']) : null,
                    high: accom.getIn(['accommodation_details', 'price_range', 'high']) ? accom.getIn(['accommodation_details', 'price_range', 'high']) : null
                },

            },
            accommodation_place_details: {
                details: {
                    photos: firstPlaceLandscape
                }
            },
            in_sabre: accom.get('in_sabre'),
            sabre_code: accom.get('sabre_code'),
            reservation_details: accom.get('reservation_details') ? accom.get('reservation_details') : {}
        }
    },

    formatActivity: function(activity, user) {
        let keywords = ''
        if (activity.get('keywords')) {
            if (typeof activity.get('keywords') === 'string') {
                keywords = activity.get('keywords')
            } else {
                keywords = activity.get('keywords').join()
            }
        }
        return {
            added_by: user.firstname,
            activity_guid: activity.get('activity_guid') ? activity.get('activity_guid') : Guid.raw(),
            id: activity.get('id') ? activity.get('id') : -1,
            name: activity.get('name'),
            place_id: activity.get('place_id') ? activity.get('place_id') : Guid.raw() + '-lunamoons',
            description: {
                excerpt: activity.getIn(['description', 'excerpt']),
                full_text: activity.getIn(['description', 'full_text']),
            },
            keywords: keywords,
            location: {
                lat: activity.getIn(['location', 'lat']),
                lon: activity.getIn(['location', 'lon']),
            },
            images: [{}],
            reservation_details: activity.get('reservation_details') ? activity.get('reservation_details') : {}
        }
    },

    getActiveLeg: function(state) {
        let activeLeg = state.getIn(['uiState', 'activeLeg'])

        if (_.isNull(activeLeg)) {
            return undefined
        }

        return state.getIn(['document', 'legs']).find((leg) => {
            return leg.get('id') === activeLeg
        })
    },

    getPrevLeg: function(state) {
        let activeLeg = state.getIn(['uiState', 'activeLeg'])

        if (_.isNull(activeLeg)) {
            return undefined
        }

        // pre-sort on 'start' so we can use index
        let sortedLegs = state.getIn(['document', 'legs']).sortBy((leg) => { return leg.getIn(['properties', 'start']) })

        let activeIndex = sortedLegs.findIndex((leg) => {
            return leg.get('id') === activeLeg
        })

        if (_.isNull(sortedLegs.getIn([activeIndex - 1])) || activeIndex === 0) {
            // try getting the origin
            if (!_.isNull(state.getIn(['document', 'properties', 'origination']))) {
                return undefined
            } else {
                return undefined
            }
        } else {
            return sortedLegs.getIn([activeIndex - 1])
        }
    },

    getNextLeg: function(state) {
        let activeLeg = state.getIn(['uiState', 'activeLeg'])

        if (_.isNull(activeLeg)) {
            return undefined
        }

        // pre-sort on 'start' so we can use index
        let sortedLegs = state.getIn(['document', 'legs']).sortBy((leg) => { return leg.getIn(['properties', 'start']) })

        let activeIndex = sortedLegs.findIndex((leg) => {
            return leg.get('id') === activeLeg
        })

        if (!sortedLegs.getIn([activeIndex + 1])) {
            // try getting the origin
            if (!_.isNull(state.getIn(['document', 'properties', 'return']))) {
                return undefined
            } else {
                return undefined
            }
        } else {
            return sortedLegs.getIn([activeIndex + 1])
        }
    },

    getNextByLeg: function(legs, curLeg) {
        if (_.isNull(curLeg)) {
            return undefined
        }

        // pre-sort on 'start' so we can use index
        let sortedLegs = legs.sortBy((leg) => { return leg.getIn(['properties', 'start']) })

        let activeIndex = sortedLegs.findIndex((leg) => {
            return leg.get('id') === curLeg.get('id')
        })

        if (!sortedLegs.getIn([activeIndex + 1])) {
            return undefined
        } else {
            return sortedLegs.getIn([activeIndex + 1])
        }
    },

    getLastLeg: function(state) {
        let sortedLegs = state.getIn(['document', 'legs']).sortBy((leg) => { return leg.getIn(['properties', 'start']) })
        return sortedLegs.getIn([sortedLegs.size - 1])
    },

    getTransportation: function(state, legID) {
        if (_.isNull(legID)) {
            return undefined
        }

        return state.getIn(['document', 'transportation']).filter((transportation) => {
            return transportation.getIn(['legDep']) === legID || transportation.getIn(['legArr']) === legID
        })
    }
}
